import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CommercialTimeMasterPage() {
    const navigate = useNavigate();

    // Default start date is today
    const [startDate, setStartDate] = useState(new Date().toISOString().split('T')[0]);
    const [projectDuration, setProjectDuration] = useState(4); // weeks

    // Calculate delivery date
    const start = new Date(startDate);
    const end = new Date(start);
    end.setDate(start.getDate() + (projectDuration * 7));

    const today = new Date();
    const delay = Math.floor((start - today) / (1000 * 60 * 60 * 24));

    // Penalité de retard : +1 jour d'hésitation = +3 jours de livraison (effet surcharge)
    const penalty = delay > 0 ? delay * 2 : 0;
    end.setDate(end.getDate() + penalty);

    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    const deliveryDateString = end.toLocaleDateString('fr-FR', options);

    return (
        <div style={{ height: '100vh', width: '100vw', background: '#0f172a', color: 'white', fontFamily: 'Inter, sans-serif', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>

            <div style={{ textAlign: 'center', marginBottom: 40 }}>
                <h1 style={{ fontSize: '3rem', fontWeight: 900, marginBottom: 10 }}>🗓️ Time Master</h1>
                <p style={{ opacity: 0.6, fontSize: '1.2rem' }}>Définissons votre date de succès.</p>
            </div>

            <div style={{ background: 'rgba(255,255,255,0.05)', padding: 50, borderRadius: 24, width: '100%', maxWidth: 800, border: '1px solid rgba(255,255,255,0.1)' }}>

                <div style={{ display: 'flex', gap: 40, alignItems: 'center', justifyContent: 'center', marginBottom: 40 }}>
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ marginBottom: 10, fontWeight: 700, color: '#94a3b8' }}>DÉBUT DU PROJET</div>
                        <input
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            style={{ padding: '15px 25px', borderRadius: 12, border: 'none', fontSize: '1.2rem', background: 'white', color: 'black', fontWeight: 700, cursor: 'pointer' }}
                        />
                    </div>

                    <div style={{ fontSize: '2rem', opacity: 0.3 }}>➜</div>

                    <div style={{ textAlign: 'center' }}>
                        <div style={{ marginBottom: 10, fontWeight: 700, color: '#94a3b8' }}>LIVRAISON ESTIMÉE</div>
                        <div className="animate-pop" key={deliveryDateString} style={{ padding: '15px 40px', borderRadius: 12, background: penalty > 5 ? '#ef4444' : '#22c55e', color: 'white', fontSize: '1.5rem', fontWeight: 800 }}>
                            {deliveryDateString} 🥂
                        </div>
                    </div>
                </div>

                {/* Timeline Visual */}
                <div style={{ position: 'relative', height: 10, background: '#334155', borderRadius: 5, marginBottom: 20 }}>
                    <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: `${100 / (1 + (penalty / 10))}%`, background: penalty > 5 ? '#ef4444' : '#3b82f6', borderRadius: 5, transition: 'width 0.5s, background 0.5s' }} />
                </div>

                {/* Message Impact */}
                <div style={{ textAlign: 'center', minHeight: 60 }}>
                    {delay > 0 ? (
                        <div style={{ color: '#ef4444', fontWeight: 700, fontSize: '1.2rem', animation: 'shake 0.5s' }}>
                            ⚠️ Attention : {delay} jours d'attente = +{penalty} jours de délai final.
                            <br /> <span style={{ fontSize: '0.9rem', opacity: 0.8 }}>(Planning surchargé)</span>
                        </div>
                    ) : (
                        <div style={{ color: '#22c55e', fontWeight: 700, fontSize: '1.2rem' }}>
                            ✅ Planning Optimal. On lance maintenant ?
                        </div>
                    )}
                </div>

                <div style={{ textAlign: 'center', marginTop: 40 }}>
                    <button onClick={() => navigate('/commercial/sign')} style={{ padding: '20px 50px', borderRadius: 50, border: 'none', background: 'white', color: '#0f172a', fontSize: '1.5rem', fontWeight: 900, cursor: 'pointer', boxShadow: '0 10px 40px rgba(255,255,255,0.1)' }}>
                        BLOQUER CETTE DATE 🔒
                    </button>
                </div>

            </div>

            <button onClick={() => navigate('/commercial/launchpad')} style={{ position: 'fixed', bottom: 30, background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.3)', cursor: 'pointer' }}>Retour</button>

            <style>{`
                .animate-pop { animation: pop 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275); }
                @keyframes pop { from { transform: scale(0.9); } to { transform: scale(1); } }
                @keyframes shake { 0%, 100% { transform: translateX(0); } 25% { transform: translateX(-5px); } 75% { transform: translateX(5px); } }
            `}</style>
        </div>
    );
}
